"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var FindRecipientInfo_1 = require("owa-recipient-common/lib/components/FindRecipientInfo");
var legacy_1 = require("satcheljs/lib/legacy");
exports.default = legacy_1.action('shiftFindResultHighlightIndex')(function shiftFindResultHighlightIndex(recipientWell, isIncrement, infoType) {
    // Only shift highlight index when find result is visible
    if (recipientWell.shouldShowFindResult) {
        var findResultCount = recipientWell.findResultSet.length;
        if (isIncrement) {
            recipientWell.findResultHightlightIndex++;
        }
        else {
            recipientWell.findResultHightlightIndex--;
        }
        // Incrementing on last item loops back to the first item.
        // Decrementing on first item loops back to the last item.
        var totalOptions = findResultCount +
            (infoType === FindRecipientInfo_1.FindRecipientInfoType.SearchDirectory ||
                infoType === FindRecipientInfo_1.FindRecipientInfoType.UseAddress
                ? 1
                : 0);
        recipientWell.findResultHightlightIndex =
            (recipientWell.findResultHightlightIndex + totalOptions) % totalOptions;
    }
});
//# sourceMappingURL=shiftFindResultHighlightIndex.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/owa-readwrite-recipient-well/lib/actions/shiftFindResultHighlightIndex.js
// module id = 3397
// module chunks = 2 3